(function () {

    'use strict';

    angular.module('iplusjs.utils.schluesselWerte', [
        'iplusjs.config',
        'iplusjs.utils.misc',
        'lodash'
    ])
        .service('SchluesselWerteUtilsService', SchluesselWerteUtilsService);

    SchluesselWerteUtilsService.$inject = [
        '$http',
        'AppConfig',
        'lodash',
        'MiscUtilsService'
    ];

    var swProperties = ('typ wert bezeichnung sortierKz verfuegbar').split(' ');
    function SchluesselWerteUtilsService($http, AppConfig, _, MiscUtilsService) {
        var that = this,
            schluesselwerte = {};

        that.fetch = fetchFromServer;
        that.create = create;
        that.createFromArray = createFromArray;
        that.isSchluesselWert = isSchluesselWert;
        that.get = get;
        that.equals = equals;
        that.setSchluesselwert = setSchluesselwert;
        that.getSchluesselwert = getSchluesselwert;
        that.getBezeichnung = getBezeichnung;
        function fetchFromServer(serviceName, params, swPath, swPrefix) {
            swPath = swPath || '';

            var serviceData = {
                method: 'GET',
                url: (swPrefix || AppConfig.API.services.swPrefix) + swPath + serviceName,
                cache: true,
                params: {
                    sort: 'bezeichnung'
                }
            };

            serviceData = _.merge(serviceData, params);

            return $http(serviceData).then(function (response) {
                var sw = [];

                if (_.isArray(response.data)) {
                    sw = response.data;
                }
                schluesselwerte[serviceName] = sw;
                return sw;
            });
        }
        function create() {
            var schluesselWert = {},
                obj = {};

            if (_.isObject(arguments[0])) {
                obj = arguments[0];
            } else if (arguments.length > 0) {
                obj.typ = arguments[0];
                obj.wert = arguments[1];
                obj.bezeichnung = arguments[2];
                obj.sortierKz = arguments[3];
            }

            obj.wert = _.toString(obj.wert);

            if (MiscUtilsService.isEmpty(obj) || MiscUtilsService.isEmpty(obj.typ) || MiscUtilsService.isEmpty(obj.wert)) {
                return schluesselWert;
            }

            swProperties.forEach(function (prop) {
                if (obj.hasOwnProperty(prop)) { // eslint-disable-line
                    schluesselWert[prop] = obj[prop];
                }
            });

            ['bezeichnung', 'sortierKz'].forEach(function (prop) {
                schluesselWert[prop] = MiscUtilsService.isEmpty(schluesselWert[prop]) ? obj.wert : schluesselWert[prop];
            });

            return _.merge(schluesselWert, {
                verfuegbar: MiscUtilsService.isEmpty(schluesselWert.verfuegbar) ? true : schluesselWert.verfuegbar
            });
        }
        function createFromArray(typ, swArray) {
            var schluesselwerte = [];

            if (MiscUtilsService.isEmpty(typ) || MiscUtilsService.isEmpty(swArray)) {
                return [];
            }

            swArray.forEach(function (sw) {
                var schluesselwert = sw;
                schluesselwert.typ = typ;

                schluesselwerte.push(create(schluesselwert));
            });

            return schluesselwerte;
        }
        function isSchluesselWert(value) {
            return _.isObject(value) && !_.difference(swProperties, _.keys(value)).length;
        }
        function get(obj, prop) {
            obj = obj || {};

            return _.get(obj, prop);
        }
        function equals(objBase, objCompare) {
            var hasPropertiesWertAndTyp = true;

            objBase = objBase || {};
            objCompare = objCompare || {};

            if (MiscUtilsService.isAtLeastOneEmpty(objBase, objCompare)) {
                return false;
            }

            _.each([objBase, objCompare], function (obj) {
                if (!_.has(obj, 'typ') || !_.has(obj, 'wert')) {
                    hasPropertiesWertAndTyp = false;
                    return false;
                }
            });

            return hasPropertiesWertAndTyp && _.isEqual(objBase.typ, objCompare.typ) && _.isEqual(objBase.wert, objCompare.wert);
        }
        function setSchluesselwert(swName, sw) {
            schluesselwerte[swName] = sw;
        }
        function getSchluesselwert(swName) {
            return schluesselwerte[swName] || [];
        }
        function getBezeichnung(obj, defaultBezeichnung) {
            return _.without([
                _.get(obj, 'wwwBezeichnung'),
                _.get(obj, 'bezeichnung'),
                _.get(obj, 'wert')
            ], undefined, null, '')[0] || defaultBezeichnung;
        }
    }

})();
